import React from 'react';
import { DatePicker } from 'antd';

import Base from './Base';

const valueExtractor = value => value;

const AntDatePicker = props => {
  return (
    <Base
      {...props}
      style={{ width: '100%' }}
      component={DatePicker}
      valueExtractor={valueExtractor}
      showTime={{ format: 'HH:mm' }}
      format="YYYY-MM-DD HH:mm"
    />
  );
};

export default AntDatePicker;
